import React, { useCallback, useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import Period from '../Appointment/period';
import PeriodSelection from '../Appointment/PeriodSelection';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { setSumPeriod } from '../../../redux/slices/scheduler/summarySlice';
import { updateSearchParams } from '../../../redux/slices/scheduler/appointmentSlice';
import setUiMessage from '../../../Utilities/Tostify';

function AppSummary() {
  const dispatch = useDispatch();

  const { user } = useSelector((store) => store.auth);
  const { sumPeriodFilter } = useSelector((store) => store.summary);
  const { appSearchPrams } = useSelector((store) => store.appointment);

  const [allLocation, setAllLocation] = useState(null);
  const [allSumData, setAllSumData] = useState(null);
  const [allResource, setAllResource] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/auth/getAllLocation', {});
        if (response.status === 200) {
          setAllLocation(response?.data?.allLocation);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/auth/getappsummary', {
          provider: appSearchPrams.allProviders,
          selectedDate: sumPeriodFilter?.name,
          startDate: format(new Date(sumPeriodFilter.startDate), 'yyyy-MM-dd'),
          endDate: format(new Date(sumPeriodFilter?.endDate), 'yyyy-MM-dd'),
          locId: appSearchPrams.clinicLocation,
          staffUserId: user?.id,
        });
        if (response.status === 200) {
          setAllSumData(response?.data);
          setAllResource(response?.data.allResource);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [sumPeriodFilter, appSearchPrams, user]);

  const handleLocation = useCallback(
    (e) => {
      dispatch(
        updateSearchParams({
          key: 'clinicLocation',
          value: e.target.value,
        })
      );
    },
    [dispatch]
  );
  const handleResource = (e) => {
    dispatch(
      updateSearchParams({
        key: 'allProviders',
        value: e.target.value,
      })
    );
  };

  return (
    <div id="schSumrySection" className="sch-Sumry-Section">
      <div className="child-body-rw appt-sec-fst-rw">
        <Period
          periodFilter={sumPeriodFilter}
          setPeriodFilter={(obj) => dispatch(setSumPeriod(obj))}
        />
        <PeriodSelection
          selectedPeriod={sumPeriodFilter}
          setPeriodFilter={(obj) => dispatch(setSumPeriod(obj))}
        />
        <div className="appt-search">
          <span className="appt-loc-val">
            <select
              className="appt-col-slct"
              value={appSearchPrams.clinicLocation}
              onChange={handleLocation}
            >
              <option value="">All Locations</option>
              {allLocation &&
                allLocation.map((loc, idx) => {
                  return (
                    <option key={idx} value={loc?.id}>
                      {loc?.location_code}
                    </option>
                  );
                })}
            </select>
          </span>
        </div>
        <div className="appt-search">
          <span className="appt-loc-val">
            <select
              className="appt-col-slct"
              value={appSearchPrams.allProviders}
              onChange={handleResource}
            >
              <option value="">All</option>
              {allResource &&
                allResource.map((note, idx) => {
                  return (
                    <option key={idx} value={note?.id}>
                      {note?.resName}
                    </option>
                  );
                })}
            </select>
          </span>
        </div>
        <div className="appt-sumary">
          <span className="appt-loc-val">
            <span className="prnt-btn">Print Summary</span>
          </span>
        </div>
      </div>
      <div className="appt-body-main">
        <div className="appt-smry-blk">
          <div className="appt-smry-hdng bold">SUMMARY</div>
          <div className="appt-smry-inr-hdr">
            <span className="appt-smry-inr-lbl bold">Appointments</span>
            <span className="appt-smry-inr-lbl bold">Visited</span>
            <span className="appt-smry-inr-lbl bold">$ at front</span>
            <span className="appt-smry-inr-lbl bold">Pending Notes</span>
          </div>
          <div className="appt-smry-inr-bdy">
            <div className="appt-smry-inr-bdy-rw">
              <span className="appt-smry-inr-lbl">
                {(allSumData?.summaryGrid &&
                  allSumData?.summaryGrid[2].slice(-1)) ||
                  0}
              </span>
              <span className="appt-smry-inr-lbl">
                {(allSumData?.summaryGrid &&
                  allSumData?.summaryGrid[3].slice(-1)) ||
                  0}
              </span>
              <span className="appt-smry-inr-lbl">
                {allSumData?.collectionTotal || '$0.00'}
              </span>
              <span className="appt-smry-inr-lbl">
                {allSumData?.pendingNoteTotRowSum}
              </span>
            </div>
          </div>
        </div>
        <div className="appt-smry-blk detald-smry">
          <div className="appt-smry-hdng bold">SUMMARY of APPOINTMENTS</div>

          <div className="appt-smry-inr-hdr">
            {allSumData?.summaryGrid &&
              allSumData?.summaryGrid[1].map((d, i) => {
                return (
                  <span key={i} className="appt-smry-inr-lbl bold">
                    <div dangerouslySetInnerHTML={{ __html: d }} />
                  </span>
                );
              })}
          </div>
          <div className="appt-smry-inr-bdy">
            {allSumData?.summaryGrid &&
              Object.keys(allSumData?.summaryGrid).map((item, i) => {
                return (
                  item !== '1' && (
                    <div
                      key={i}
                      className={
                        i % 2 === 0
                          ? 'appt-smry-inr-bdy-rw alt-rw'
                          : 'appt-smry-inr-bdy-rw'
                      }
                    >
                      {allSumData?.summaryGrid[item] &&
                        allSumData?.summaryGrid[item].map((val, i) => {
                          return (
                            <span key={i} className="appt-smry-inr-lbl">
                              {val}
                            </span>
                          );
                        })}
                    </div>
                  )
                );
              })}
          </div>
        </div>
        <div className="appt-smry-blk detald-smry">
          <div className="appt-smry-hdng bold">
            SUMMARY of PROVIDER's ENCOUNTER
          </div>
          <div className="appt-smry-inr-hdr">
            {allSumData?.summaryGrid &&
              allSumData?.summaryGrid[1].map((d, i) => {
                return (
                  <span key={i} className="appt-smry-inr-lbl bold">
                    <div dangerouslySetInnerHTML={{ __html: d }} />
                  </span>
                );
              })}
          </div>
          <div className="appt-smry-inr-bdy">
            {allSumData?.resGrid &&
              Object.keys(allSumData?.resGrid).map((item, i) => {
                return (
                  <div
                    key={i}
                    className={
                      i % 2 === 0
                        ? 'appt-smry-inr-bdy-rw'
                        : 'appt-smry-inr-bdy-rw alt-rw'
                    }
                  >
                    {/* <span className="appt-smry-inr-lbl">{item}</span> */}
                    {allSumData?.resGrid[item] &&
                      Object.values(allSumData?.resGrid[item]).map((val, i) => {
                        return (
                          <span key={i} className="appt-smry-inr-lbl">
                            {val}
                          </span>
                        );
                      })}
                  </div>
                );
              })}
          </div>
          {/* <div className="appt-smry-inr-hdr">
            <span className="appt-smry-inr-lbl bold">Total</span>
            <span className="appt-smry-inr-lbl">
              <span className="bold orange pov-smry-bg">241</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold orange pov-smry-bg">263</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold orange pov-smry-bg">263</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold orange pov-smry-bg">241</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold orange pov-smry-bg">212</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold orange pov-smry-bg">1150</span>
            </span>
          </div> */}
        </div>
        <div className="appt-smry-blk detald-smry">
          <div className="appt-smry-hdng bold">
            SUMMARY of PAYMENT's COLLECTED AT FRONT
          </div>
          <div className="appt-smry-inr-hdr">
            {allSumData?.summaryGrid &&
              allSumData?.summaryGrid[1].map((d, i) => {
                return (
                  <span key={i} className="appt-smry-inr-lbl bold">
                    <div dangerouslySetInnerHTML={{ __html: d }} />
                  </span>
                );
              })}
          </div>
          <div className="appt-smry-inr-bdy">
            {allSumData?.collectionGrid &&
              Object.keys(allSumData?.collectionGrid).map((item, i) => {
                return (
                  <div
                    key={i}
                    className={
                      i % 2 === 0
                        ? 'appt-smry-inr-bdy-rw alt-rw'
                        : 'appt-smry-inr-bdy-rw'
                    }
                  >
                    {allSumData?.collectionGrid[item] &&
                      allSumData?.collectionGrid[item].map((val, i) => {
                        return (
                          <span key={i} className="appt-smry-inr-lbl">
                            {val}
                          </span>
                        );
                      })}
                  </div>
                );
              })}
          </div>
          {/* <div className="appt-smry-inr-hdr">
            <span className="appt-smry-inr-lbl bold">Total</span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$150.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$40.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$135.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$150.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$00.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$475.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$475.00</span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold seagreen pov-smry-bg">$475.00</span>
            </span>
          </div> */}
        </div>
        <div className="appt-smry-blk qdetald-smry">
          <div className="appt-smry-hdng bold">
            SUMMARY of PENDING NOTES
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            <span>{`[${
              allSumData && (allSumData.startDate || '00-00-0000')
            } to ${allSumData && (allSumData.endDate || '00-00-0000')}]`}</span>
          </div>
          <div className="appt-smry-inr-hdr">
            <span className="appt-smry-inr-lbl bold">&nbsp;</span>
            <span className="appt-smry-inr-lbl bold">Total</span>
            <span className="appt-smry-inr-lbl bold">To Record</span>
            <span className="appt-smry-inr-lbl bold">For Signature</span>
            <span className="appt-smry-inr-lbl bold">For Co-Sign</span>
          </div>
          <div className="appt-smry-inr-bdy">
            {allSumData?.pendingNoteGrid &&
              Object.keys(allSumData?.pendingNoteGrid).map((key, i) => {
                return (
                  <div
                    className={
                      i % 2 === 0
                        ? 'appt-smry-inr-bdy-rw'
                        : 'appt-smry-inr-bdy-rw alt-rw'
                    }
                    key={i}
                  >
                    <span className="appt-smry-inr-lbl">
                      {allSumData?.pendingNoteGrid[key]?.resName}
                    </span>
                    <span className="appt-smry-inr-lbl">
                      {allSumData?.pendingNoteGrid[key]?.total || 0}
                    </span>
                    <span className="appt-smry-inr-lbl">
                      {allSumData?.pendingNoteGrid[key]?.pending || 0}
                    </span>
                    <span className="appt-smry-inr-lbl">
                      {allSumData?.pendingNoteGrid[key]?.unsigned || 0}
                    </span>
                    <span className="appt-smry-inr-lbl">
                      {allSumData?.pendingNoteGrid[key]?.cosign || 0}
                    </span>
                  </div>
                );
              })}
          </div>
          <div className="appt-smry-inr-hdr">
            <span className="appt-smry-inr-lbl bold">Total</span>
            <span className="appt-smry-inr-lbl">
              <span className="bold bpink pov-smry-bg">
                {allSumData?.pendingNoteTotRow &&
                  (allSumData?.pendingNoteTotRow?.penTotal || 0) +
                    (allSumData?.pendingNoteTotRow?.signTotal || 0) +
                    (allSumData?.pendingNoteTotRow?.cosignTotal || 0)}
              </span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold bpink pov-smry-bg">
                {allSumData?.pendingNoteTotRow &&
                  (allSumData?.pendingNoteTotRow?.penTotal || 0)}
              </span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold bpink pov-smry-bg">
                {allSumData?.pendingNoteTotRow &&
                  (allSumData?.pendingNoteTotRow?.signTotal || 0)}
              </span>
            </span>
            <span className="appt-smry-inr-lbl">
              <span className="bold bpink pov-smry-bg">
                {allSumData?.pendingNoteTotRow &&
                  (allSumData?.pendingNoteTotRow?.cosignTotal || 0)}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppSummary;

// const ModalWindow = {
//   init() {
//     document.body.addEventListener('click', (e) => {
//       if (e.target.classList.contains('modal__close')) {
//         this.closeModal(e.target);
//       }
//     });

//     this.openModal();
//   },

//   getHtmlTemplate(modalOptions) {
//     return `
//             <div className="modal__overlay">
//                 <div className="modal__window">
//                     <div className="modal__titlebar">
//                         <span className="modal__title">${modalOptions.title}</span>
//                         <button className="modal__close material-icons">close</button>
//                     </div>
//                     <div className="modal__content">
//                         ${modalOptions.content}
//                     </div>
//                 </div>
//             </div>
//         `;
//   },

//   openModal(modalOptions = {}) {
//     modalOptions = Object.assign(
//       {
//         title: 'Modal Title',
//         content: 'Modal Content',
//       },
//       modalOptions
//     );

//     const modalTemplate = this.getHtmlTemplate(modalOptions);
//     document.body.insertAdjacentHTML('afterbegin', modalTemplate);
//   },

//   closeModal(closeButton) {
//     const modalOverlay = closeButton.parentElement.parentElement.parentElement;
//     document.body.removeChild(modalOverlay);
//   },
// };

// document.addEventListener('DOMContentLoaded', () => ModalWindow.init());
